export default __webpack_public_path__ + "static/media/SeaLife_05.2c0b3951.png";